package one.healthium.profile.navigation.update_weight

import com.arkivanov.decompose.ComponentContext
import kotlin.time.Instant

class DefaultUpdateWeightComponent(
    componentContext: ComponentContext,
    override val weight: Float,
    override val date: Instant,
    private val onWeightUpdated: () -> Unit,
    private val onCloseClicked: () -> Unit
) : UpdateWeightComponent, ComponentContext by componentContext {
    override fun onWeightUpdated() {
        onWeightUpdated.invoke()
    }

    override fun onCloseClicked() {
        onCloseClicked.invoke()
    }
}